import { render } from "./index.vue?vue&type=template&id=70ec0bd1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=70ec0bd1&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/sns-pc-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ec0bd1"]])

export default __exports__